export function pad(string, size) {
    var s = String(string);

    while (s.length < (size || 2)) {
        s = "0" + s;
    }

    return s;
}


// Currrently the (awful) API sends html AND json in the exact same response
// This is why we need to trim the non-json content.
export function purify(str) {
    let first = str.indexOf("{");
    let last = str.lastIndexOf("}");
    return str.slice(first, last+1);
}

/**
 * [Return a string in lower caze except the first letter]
 * @param  {String} string [String to capitalize]
 * @return {String}        [The capitalize string]
 */
export function capitalize(str) {
    var string = str.trim().toLowerCase();

    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * [slugify Return a string in lower case with each white space replace by an hyphen]
 * @param  {String} str [String to slugify]
 * @return {String}     [The slugify string]
 */
export function slugify(str) {
    var string = str.trim().toLowerCase();
    string = string.replace(/\s/g, "-");

    return string;
}